import { generateSeoProps } from '../generateSeoProps';

import { toIsoDate } from 'utils/dateUtils';
export const getLecturesSeoProps = ({ title = '', description = '', id = '', slug = '' }) => {
	return generateSeoProps({
		title: `${title} - Pharmuni Course`,
		description: description,
		canonical: `courses/${id}/${slug}`,
		noIndex: false
	});
};

const BEST_RATING = 5;
const WORST_RATING = 1;

export const getLecturesJsonLd = ({ lecture, reviews = [], id = '', slug = '' }) => {
	if (!lecture?.title) return null;

	const rateCount = Number(lecture.rate_count) || 0;
	const rateAverage = Number(lecture.rate_average) || 0;

	const jsonLd = {
		'@context': 'https://schema.org',
		'@type': 'Course',
		name: lecture.title,
		description: lecture.meta_description || lecture.short_introduction,
		url: `https://pharmuni.com/courses/${id}/${slug}`,
		provider: {
			'@type': 'Organization',
			name: 'Pharmuni',
			sameAs: 'https://pharmuni.com'
		}
	};

	if (typeof lecture.image === 'string' && lecture.image.startsWith('http')) {
		jsonLd.image = lecture.image;
	}

	if (rateCount > 0 && rateAverage > 0) {
		jsonLd.aggregateRating = {
			'@type': 'AggregateRating',
			ratingValue: rateAverage,
			ratingCount: rateCount,
			bestRating: BEST_RATING,
			worstRating: WORST_RATING
		};
	}

	const reviewList = reviews
		.filter((review) => review?.comment && review?.name)
		.map((review) => {
			const datePublished = toIsoDate(review.date);
			return {
				'@type': 'Review',
				author: { '@type': 'Person', name: review.name },
				reviewRating: {
					'@type': 'Rating',
					ratingValue: review.rate,
					bestRating: BEST_RATING,
					worstRating: WORST_RATING
				},
				reviewBody: review.comment,
				...(datePublished ? { datePublished } : {})
			};
		});

	if (reviewList.length > 0) {
		jsonLd.review = reviewList;
	}

	return jsonLd;
};
